import { render, staticRenderFns } from "./CommentBubble.vue?vue&type=template&id=51f4d36d"
import script from "./CommentBubble.vue?vue&type=script&lang=js"
export * from "./CommentBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports